import { PrimaryKeyValueModel } from '../models/primary-key-and-value.model';

export const getPrimaryKeys = (primaryKeyValue: PrimaryKeyValueModel[]): string[] =>
	primaryKeyValue.map((keyValue: PrimaryKeyValueModel) => keyValue.primaryKey);

export const mapPrimaryKeysArrayToObject = (
	primaryKeyValue: PrimaryKeyValueModel[]
): { [key: string]: string | number | boolean } =>
	primaryKeyValue.reduce((acc, item) => ((acc[item.primaryKey] = item.primaryKeyValue), acc), {});
